import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, Waves, LogIn, LogOut, Mail, Phone, Menu, X, Gift, UserCircle } from 'lucide-react';
import AuthPrompt from './AuthPrompt';

const getLoggedInUser = () => {
  try {
    const user = JSON.parse(localStorage.getItem("user") || "null");
    return user && (user._id || user.id || user.email) ? user : null;
  } catch (error) {
    return null;
  }
};

const PremiumNavbar = () => {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showAuthPrompt, setShowAuthPrompt] = useState(false);
  const [loggedIn, setLoggedIn] = useState(() => Boolean(getLoggedInUser()));

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleProfileClick = (event) => {
    event.preventDefault();
    setIsMobileMenuOpen(false);
    if (loggedIn) {
      navigate("/profile");
      return;
    }
    setShowAuthPrompt(true);
  };

  const handleLoginClick = (event) => {
    event.preventDefault();
    setIsMobileMenuOpen(false);
    navigate("/login");
  };

  const handleLogoutClick = (event) => {
    event.preventDefault();
    localStorage.removeItem("cart");
    localStorage.removeItem("selectedAddons");
    localStorage.removeItem("addons");
    localStorage.removeItem("finalPrice");
    localStorage.removeItem("user");
    setLoggedIn(false);
    setIsMobileMenuOpen(false);
    navigate("/");
  };

  const navLinks = [
    { name: 'Home', url: '/', icon: <Home size={18} /> },
    { name: 'About Us', url: 'about', icon: <Waves size={18} /> },
    { name: 'Packages', url: 'packages', icon: <Waves size={18} /> },
    { name: 'Contact', url: 'contact', icon: <Mail size={18} /> },
    
    // Conditionally spread profile & logout if logged in, otherwise include login
    ...(loggedIn
      ? [
          { name: 'Profile', url: '/profile', icon: <UserCircle size={18} />, onClick: handleProfileClick },
          { name: 'Logout', url: '/', icon: <LogOut size={18} />, onClick: handleLogoutClick },
        ]
      : [
          { name: 'Login', url: '/login', icon: <LogIn size={18} />, onClick: handleLoginClick },
        ]),
  ];

  const phoneNumber = "+917977600563";

  return (
    <nav className="ibn-navbar-wrapper">
      <div className="ibn-navbar-container">
        
        {}
        {/* Left Side: Solid White Logo Container */}
        <div className="ibn-logo-block">
          <a href="/" className="ibn-logo-link">
            <img 
              src="/assets/img/indiaboatslogo.png" 
              alt="India Boats" 
              className="ibn-logo-img" 
            />
          </a>
          {/* Angle element to seamlessly transition into the blue background */}
          <div className="ibn-logo-angle"></div>
        </div>

        {}
        {/* Middle: Modern MMT-Style Navigation Links (Hidden on Mobile) */}
        <div className="ibn-middle-links-section">
          {navLinks.map((link, index) => (
            <a
              key={index}
              href={link.url}
              className="ibn-nav-item"
              onClick={link.onClick}
            >
              <span className="ibn-nav-icon">{link.icon}</span>
              <span className="ibn-nav-label">{link.name}</span>
              <span className="ibn-nav-underline"></span>
            </a>
          ))}
        </div>

        {}
        {/* Right Side: Premium CTA & Hamburger */}
       <div className="ibn-right-section">

  {/* Desktop Login Button */}
  {/* <a href="/gift" className="ibn-cta-button ibn-desktop-login">
    
    <Gift size={14} className="ibn-cta-phone-icon" />
    <span>Gift Experience</span>
  </a> */}

  {/* Mobile Call Button */}
  <a
    href={`tel:${phoneNumber}`}
    className="ibn-cta-button ibn-mobile-call"
  >
    <Phone size={14} className="ibn-cta-phone-icon" />
    <span>Call Now</span>
  </a>

  {/* Hamburger */}
  <button
    className="ibn-hamburger-btn"
    onClick={toggleMobileMenu}
    aria-label="Toggle Menu"
  >
    {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
  </button>

</div>

      </div>

      {}
      {/* Mobile Menu Drawer (Fully structured and correctly closed) */}
      <div className={`ibn-mobile-drawer ${isMobileMenuOpen ? 'open' : ''}`}>
        <div className="ibn-drawer-overlay" onClick={toggleMobileMenu}></div>
        <div className="ibn-drawer-content">
          <div className="ibn-drawer-header">
            <div className="ibn-drawer-logo">
              <img src="/assets/img/indiaboatslogo.png" alt="" />
            </div>
            <button className="ibn-drawer-close" onClick={toggleMobileMenu}>
              <X size={24} />
            </button>
          </div>

          <div className="ibn-drawer-body">
            {navLinks.map((link, index) => (
              <a
                key={index}
                href={link.url}
                className="ibn-drawer-item"
                onClick={link.onClick || toggleMobileMenu}
              >
                <span className="ibn-drawer-icon">{link.icon}</span>
                <span className="ibn-drawer-label">{link.name}</span>
              </a>
            ))}
          </div>

          <div className="ibn-drawer-footer">
              {loggedIn ? (
                <a href="/" className="ibn-drawer-cta" onClick={handleLogoutClick}>
                  <LogOut size={16} />
                  <span>Logout</span>
                </a>
              ) : (
                <a href="/login" className="ibn-drawer-cta" onClick={handleLoginClick}>
                  <LogIn size={16} />
                  <span>Login</span>
                </a>
              )}
            <a href={`tel:${phoneNumber}`} className="ibn-drawer-cta">
              <Phone size={16} />
              <span>Call Us Now</span>
            </a>
            <span className="ibn-drawer-phone-val">{phoneNumber}</span>
          </div>
        </div>
      </div>

      <AuthPrompt
        open={showAuthPrompt}
        title="Login required"
        message="Please log in or sign up first to view your profile."
        primaryLabel="Log In"
        primaryPath="/login"
        secondaryLabel="Sign Up"
        secondaryPath="/signup"
        onClose={() => setShowAuthPrompt(false)}
      />
    </nav>
  );
};

export default PremiumNavbar;